module.exports = __webpack_public_path__ + "img/side_slit_length.c51b0a4d.png";